import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ScrollText } from "lucide-react";

export default function AdminAuditLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/audit-log").then(r => setItems(r.data || [])).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Audit log</h1>
      <p className="text-sm text-slate-600 mb-6">Storico delle azioni rilevanti sulla piattaforma.</p>
      <div className="cxo-card p-6">
        {items.length ? (
          <ul className="divide-y divide-slate-100">
            {items.map(l => (
              <li key={l.id} className="py-3"><p className="text-sm text-slate-900"><strong>{l.action}</strong> su {l.target_type} ({l.target_id})</p><p className="text-xs text-slate-500">{l.created_at}</p></li>
            ))}
          </ul>
        ) : <div className="text-center text-slate-500 py-10"><ScrollText size={32} className="mx-auto text-slate-300 mb-2" />Nessun evento registrato.</div>}
      </div>
    </div>
  );
}
